import { AdminTableColumnTextProps } from './admin-table-column-text-props';
import React from 'react';
import { TableColumnText } from '@mint/ui';
import styled from 'styled-components';

type T = React.FunctionComponent<AdminTableColumnTextProps>;

export const AdminTableColumnText = styled<T>(TableColumnText)`
  display: inline-block;
  flex: 1;
  overflow: hidden;
  padding-right: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
